import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOffTargetVariant1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 2.5,
			width: 49,
			height: 49,
			rx: 24.5,
			fill: "currentColor",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 2.5,
			width: 49,
			height: 49,
			rx: 24.5,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 2.18557e-08C26.4477 9.78513e-09 26 0.447715 26 1L26 4C26 4.55228 26.4477 5 27 5C27.5523 5 28 4.55228 28 4L28 1C28 0.447715 27.5523 3.39263e-08 27 2.18557e-08Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 54C27.5523 54 28 53.5523 28 53L28 50C28 49.4477 27.5523 49 27 49C26.4477 49 26 49.4477 26 50L26 53C26 53.5523 26.4477 54 27 54Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54 27C54 26.4477 53.5523 26 53 26L50 26C49.4477 26 49 26.4477 49 27C49 27.5523 49.4477 28 50 28L53 28C53.5523 28 54 27.5523 54 27Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.40025e-08 27C2.86549e-08 27.5523 0.447715 28 1 28L4 28C4.55228 28 5 27.5523 5 27C5 26.4477 4.55228 26 4 26L1 26C0.447715 26 9.93502e-08 26.4477 6.40025e-08 27Z",
			fill: "currentColor"
		})
	]
});
export default SvgOffTargetVariant1;
